import { useContext, useEffect, useState } from "react";
import { createContext } from "react";

const TabManagerContext = createContext({});

const TabManagerProvider = ({ children }) => {
    const [tabs, setTabs] = useState([]);
    //tab example
    /**
     * tabs = [
     *  {
     *      id:"53484734783",
     *      title:"User Group",
     *      original:"./user-groups",
     *      current:"./user-group/create",
     *      time:34545232344,
     *      active: true
     *  }
     * ]
     */
    useEffect(() => {
        if (tabs.length) return;
        open({ title: "dashboard", url: "home" });
        // eslint-disable-next-line
    }, [tabs]);


    const open = ({ title, url }) => {
        //make all other tabs inactive
        tabs.forEach(tab => tab.active = false);
        //for now only have one tab per link
        for (let i = 0; i < tabs.length; i++) {
            const tab = tabs[i];
            if (tab.original === url) {
                tab.time = Date.now();
                tab.active = true;
                setTabs([...tabs]);
                return;
            };
        }
        //update the page title
        document.title = title;
        setTabs([...tabs, ...[{ id: Date.now(), title: title, original: url, current: url, time: Date.now(), active: true }]]);
    };
    const close = (id) => {
        for (let i = 0; i < tabs.length; i++) {
            const tab = tabs[i];
            if (tab.id !== id) continue;
            //if the id was active switch to the one before it
            if (tab.active) {
                tabs.splice(i, 1);
                goto(tabs.reduce((p, c) => {
                    if (p.time > c.time) return p;
                    return c;
                }, {}).id);
                break;
            }
            tabs.splice(i, 1);
            setTabs([...tabs]);
            break;
        }
    };
    const closeAll = () => setTabs([]);
    const goto = (id) => {
        //make all other tabs inactive
        tabs.forEach(tab => tab.active = false);
        for (let i = 0; i < tabs.length; i++) {
            const tab = tabs[i];
            if (tab.id !== id) continue;
            //if the id was active switch to the one before it
            tab.active = true;
            tab.time = Date.now();
            //update the page title
            document.title = tab.title;
            break;
        }
        setTabs([...tabs]);
    };
    let value = { tabs, open, close, closeAll, goto };
    return <TabManagerContext.Provider value={value}>{children}</TabManagerContext.Provider>
}

const useTabManager = () => {
    return useContext(TabManagerContext);
}

const useTabs = () => {
    return useContext(TabManagerContext).tabs;
}

export { TabManagerProvider, useTabManager, useTabs };